/**
 * TanStack Query hooks for `error-states-retry-button`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	errorStatesRetryButtonQueryKeys,
	type CreateErrorStatesRetryButtonBody,
	type ListErrorStatesRetryButtonResponse,
	type ErrorStatesRetryButtonRow,
} from "./api";

export function useErrorStatesRetryButtonList(): UseQueryResult<ListErrorStatesRetryButtonResponse, Error> {
	return useQuery({
		queryKey: errorStatesRetryButtonQueryKeys.list(),
		queryFn: list,
	});
}

export function useErrorStatesRetryButtonCreate(): UseMutationResult<ErrorStatesRetryButtonRow, Error, CreateErrorStatesRetryButtonBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: errorStatesRetryButtonQueryKeys.all });
		},
	});
}

export function useErrorStatesRetryButtonDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: errorStatesRetryButtonQueryKeys.all });
		},
	});
}
